import { PromiseWithResolver } from './PromiseWithResolver';
export default function wait(duration = 0, signal) {
    let resolver;
    const promise = new PromiseWithResolver((resolve) => {
        const timeoutId = setTimeout(resolve, duration);
        resolver = () => {
            clearTimeout(timeoutId);
            resolve();
        };
    });
    promise.resolve = resolver;
    if (signal?.aborted) {
        resolver();
        return promise;
    }
    if (signal) {
        promise.resolve = () => {
            resolver();
            signal.removeEventListener('abort', resolver);
        };
        signal.addEventListener('abort', resolver, { once: true });
    }
    return promise;
}
